export default __webpack_public_path__ + "images/WB.432f1de.png";